import { Select, SelectChangeEvent, MenuItem } from '@mui/material'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { usePromoAddInterest } from 'src/stores/PromoStore';

const menuProps = {
    PaperProps: {
        sx: {
          maxHeight: '200px',
          overflowY: 'auto',
          border: '1px solid #508A9C',
          paddingY :0,
          '& .MuiMenu-list': {
        paddingTop: 0,
        paddingBottom: 0,
      },
        },
      },
      TransitionProps: {
        onEntering: (menuElement: HTMLElement) => {
          menuElement.scrollTop = 0;
        },
      },
}
// class="MuiOutlinedInput-notchedOutline css-1ll44ll-MuiOutlinedInput-notchedOutline"
const sx = {
    height:'46px',
    minWidth: '102px',
    textAlign:'left',
    justifyContent:'center',
    border: '1.5px solid #508A9C',
    '&.Mui-selected': {
      backgroundColor: '#EEF6F8',
    },
    width:'100%',
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
}

const DropBoxSx = {
    // justifyContent: 'center',
    // textAlign: 'center',
    height:'46px',
    borderTop : '1.5px solid #508A9C'
}

const PromoInterestedSelectType = () => {
    const typeContent = ['관심없음','관심','지원준비','지원완료','임관']
    const type = usePromoAddInterest((state)=>state.type)
    const setField = usePromoAddInterest((state)=>state.setField)

    const handleTypeChange = (e:SelectChangeEvent<string>)=>{
        setField('type',e.target.value)
    }

  return (
      <Select
          value={type}
          onChange={handleTypeChange}
          renderValue={(selected) => `${selected}`}
          MenuProps={menuProps}
          sx={sx}
          IconComponent={KeyboardArrowDown}
          >
          {typeContent.map((content) => (
              <MenuItem value={content.toString()} sx={DropBoxSx}>
                  {content}
              </MenuItem>
          ))}
      </Select>
  )
}

export default PromoInterestedSelectType